<template>
  <div class="main">
      <div class="bottom-grid">
          <div class="logo">
              <h1>大卖家跨境助手</h1>
          </div>
      </div>
      <!-- register -->
      <div class="w3lhny-register">
          <div class="iconhny">
             <img style="border-radius: 50%;width: 100%;height: 100%;" src="https://img.damaijia.cn/image/dmjImg/damaijia.png"/>
           </div>
        <div class="register-form">
          <div class="form" v-if="!registerSuccess">
              <div class="form-row">
                  <span class="fa fa-user"></span>
                  <el-input placeholder="手机号" class="form-text" v-model="register.phone"></el-input>
              </div>
              <div class="form-row">
                  <span class="fa fa-lock"></span>
                  <el-input type="password" placeholder="输入密码"  class="form-text" v-model="register.password"></el-input>
              </div>
              <div class="form-row">
                  <span class="fa fa-lock"></span>
                  <el-input type="password" placeholder="再次输入密码" class="form-text" v-model="register.password1"></el-input>
              </div>
              <div class="form-row" style="position: relative;">
                  <div>
                    <el-input placeholder="验证码" class="form-text" v-model="user.vcaptcha" style="width:140px;">
                    </el-input>
                  </div>
                  <div style="position: absolute;right: 0px;z-index: 999;top: 0px;">
                    <el-image :src="vcaptchaPath" @click="getvImage()" style="height:40px;"></el-image>
                  </div>
              </div>
              <div class="form-row" style="position: relative;" v-if="false">
                  <div>
                    <el-input placeholder="请输入验证码" class="form-text"  v-model="register.vcode"></el-input>
                  </div>
                  <div style="position: absolute;right: 0px;z-index: 999;top: 0px;">
                    <el-button v-if="!isgetcode" @click="getvcode" type="primary" size="" plain class="btn-getcode">获取验证码</el-button>
                    <el-button v-if="isgetcode" type="primary" size="" plain class="btn-getcode">{{getcodeout}}秒</el-button>
                  </div>
              </div>

              <div class="form-row" id="exists_code" v-if="mcode!=''&&false">
                  <span class="fa fa-envelope"></span>
                  <el-input disabled placeholder="邀请码" class="form-text" v-model="register.mcode"></el-input>
              </div>
              <div class="form-row" id="none_code" v-if="mcode==''&&false">
                  <span class="fa fa-envelope"></span>
                  <el-input placeholder="邀请码" class="form-text" v-model="register.mcode"></el-input>
              </div>
              <div class="form-row button-login">
                  <button class="btn btn-login" @click="registerClick">注册帐号</button>
              </div>
          </div>
          <div class="form" v-else>
            <div style="font-size: 24px;color: #32cbaa;font-weight: bold;">恭喜您，注册成功</div>
            <div style="font-size: 24px;color: #2ac818;font-weight: bold;margin-top: 20px;cursor: pointer;" @click="openUrl">点击查看使用说明</div>
          </div>
        </div>
      </div>
      <div class="w3l-copyright">
          <p>© 2014-2025 深圳市大卖帮电商发展有限公司 备案号：粤ICP备2025410561号-1</p>
      </div>
  </div>
</template>

<script>
import RSAKey from '@/utils/rsa';
import {
  b64tohex,
  hex2b64
} from '@/utils/base64';
import { setAjaxToken } from "@/utils/auth";
import { Message } from 'element-ui'
import store from '@/store'
import { webregister,getcode,getToken,getPublicKey,login } from '@/api/commodity.js'
export default {
    name: 'login',
    data() {
        return {
            registerSuccess:false,
            isgetcode:false,
            getcodeout:60,
            isLogin: true,//true :登录   ，flase ：注册
            checked: false,
            loginType: true,//true ：账号登陆 false ：手机号登录
            errMsg: '错误提示的文案',
            isErrShow: false,
            captchaPath: '',
            vcaptchaPath:'',
            captchaId: '',
            token: '',
            mcode: this.$route.query.code ? this.$route.query.code : '',
            user: {
                account: '',
                password: '',
                captcha: '',
                vcaptcha:'',
            },
            register: {
              phone: '',
              password: '',
              password1: '',
              vcode: '',
              mcode:this.$route.query.code ? this.$route.query.code : '',
            },
            intervalId:null,
        }
    },
    watch: {
        loginType() {
            this.isErrShow = false
        },
        isLogin() {
            this.isErrShow = false
        }
    },
    created() {
      this.getImage();
    },
    methods: {
        openUrl() {
          window.open('https://el4l6tjrzr.feishu.cn/wiki/UM2NwDsxyiGtUhkmGV2cDSksnLh');
        },
        registerClick() {
          let that = this;
          if (that.user.vcaptcha == '') {
            Message.error('请填写图形验证码');
            return false;
          }
          if (that.register.phone == '') {
            Message.error('请填写手机号');
            return false;
          }
          if (that.register.password == '') {
            Message.error('请填写密码');
            return false;
          }
          if (that.register.password != that.register.password1) {
            Message.error('两次密码不一致');
            return false;
          }
          that.register.vcode = 'dmj';
          if (that.register.vcode == '') {
            Message.error('请填写短信验证码');
            return false;
          }
          getPublicKey(this.token).then(res => {
            let that = this;
            let rsaKey = new RSAKey();
            rsaKey.setPublic(b64tohex(res.data.m), b64tohex(res.data.p));
            let rsaPassword = hex2b64(rsaKey.encrypt(this.register.password.trim()));
            webregister(that.register.phone, rsaPassword, that.register.vcode, this.token, this.mcode).then(res => {
              if (res.data.code == 200) {
                that.registerSuccess = true;
                sessionStorage.setItem("token", that.token);
                setAjaxToken(that.token);
                localStorage.setItem("token", that.token);
                localStorage.setItem("username", res.data.username);
                localStorage.setItem("account", res.data.account);
                localStorage.setItem("phone", res.data.phone);
                localStorage.setItem("isLogin", true);
                Message.sucess('注册成功');
              } else {
                Message.error(res.data.status);
                that.getvImage();
                that.vcaptcha = "";
              }
            }).catch(err => { console.log('获取类别失败', err); })
          }).catch(err => { console.log('获取类别失败', err); })
        },
        getvcode() {
          let that = this;
          if (that.user.vcaptcha == '') {
            Message.error('请填写图形验证码');
            return false;
          }
          if (that.register.phone == '') {
            Message.error('请填写手机号');
            return false;
          }
          if (that.register.password == '') {
            Message.error('请填写密码');
            return false;
          }
          if (that.register.password != that.register.password1) {
            Message.error('两次密码不一致');
            return false;
          }
          if (!this.isgetcode) {
            getcode(that.register.phone, this.token, that.user.vcaptcha).then(res => {
              if (res.data.code == 200) {
                that.isgetcode = true;
                that.getcodeout = 60;
                that.intervalId = setInterval(function() {
                  let _time = that.getcodeout - 1;
                  if (_time <= 0) {
                    that.isgetcode = false;
                    clearInterval(that.intervalId );
                    that.getcodeout = 60;
                  } else {
                    that.isgetcode = true;
                    that.getcodeout = _time;
                  }
                }, 1000);
              } else {
                Message.error(res.data.status);
                that.getvImage();
                that.vcaptcha = "";
              }
            }).catch(err => { console.log('获取类别失败', err); })
          }
        },
        getToken(_call) {
          let _that = this;
          getToken().then(res => {
            _that.token= res.data.token;
            _call();
          }).catch(err => { console.log('获取类别失败', err); })
        },
        getImage() {
          if (this.token == '') {
            let that = this;
            this.getToken(function() {
              that.vcaptchaPath = '/api/shop/captcha/captcha.jhtml?token=' + that.token + "&t=" + new Date().getTime();
            })
          } else {
            this.vcaptchaPath = '/api/shop/captcha/captcha.jhtml?token=' + this.token + "&t=" + new Date().getTime();
          }
        },
        getvImage() {
          if (this.token == '') {
            let that = this;
            this.getToken(function() {
              that.vcaptchaPath = '/api/shop/captcha/captcha.jhtml?token=' + that.token + "&t=" + new Date().getTime();
            })
          } else {
            this.vcaptchaPath = '/api/shop/captcha/captcha.jhtml?token=' + this.token + "&t=" + new Date().getTime();
          }
        },
        login(formName) {
          let _that = this;
          if (this.user.account == '' ||
              this.user.password == ''
          ) {
              this.isErrShow = true
              this.errMsg = '请输入正确的帐号信息';
              return false;
          }
          if (this.user.captcha == '') {
              this.isErrShow = true
              this.errMsg = '请输入正确的验证码';
              return false;
          }
          getPublicKey(this.token).then(res => {
            console.log('777=>', res);
            let rsaKey = new RSAKey();
            rsaKey.setPublic(b64tohex(res.data.m), b64tohex(res.data.p));
            let rsaAccount = hex2b64(rsaKey.encrypt(this.user.account.trim()));
            let rsaPassword = hex2b64(rsaKey.encrypt(this.user.password.trim()));
            this.token = res.data.token;
            console.log(rsaPassword)
            login(rsaAccount, rsaPassword, this.user.captcha, this.token).then(res => {
              if (res.data.code == 200) {
                sessionStorage.setItem("token", this.token);
                setAjaxToken(this.token);
                localStorage.setItem("token", this.token);
                localStorage.setItem("username", res.data.username);
                localStorage.setItem("account", res.data.account);
                localStorage.setItem("phone", res.data.phone);
                localStorage.setItem("isLogin", true);
                Message.success('登录成功')
                let path = this.$route.query.redirect
                if (path == undefined || path == '' || path == null) {
                    path = '/'
                }
                console.log('path->' + path)
                this.$router.push({ path })
              } else {
                Message.error(res.data.status);
                this.getImage();
                this.captcha = "";
              }
            }).catch(err => { console.log('获取类别失败', err); })
          }).catch(err => { console.log('获取类别失败', err); })
        },

    },

}
</script>

<style>
.btn-getcode {
  width: 112px;
}
.el-input.is-disabled .el-input__inner {
    background-color: transparent !important;
}
</style>
